import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How to use MobX with create-react-app",
  "description": "",
  "published": "2016-10-27T00:00:00.000Z",
  "redirect_from": ["/blog/mobx-with-create-react-app/swizec/7158"],
  "categories": "Front End, react, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2016/10/react-eject.png",
        "alt": null
      }}></img></p>
    <p><inlineCode parentName="p">{`create-react-app`}</inlineCode>{` is the best thing that's happened to the React ecosystem since React 14 gave us functional components. No more messing around with random boilerplates or manual headaches around setting up your project from scratch.`}</p>
    <p>{`Instead, you run `}<inlineCode parentName="p">{`create-react-app MyThing`}</inlineCode>{`, and it sets everything up.`}</p>
    <p>{`If you like MobX, there's a crucial piece missing: decorators. You don't have to use decorators with MobX, but that's like saying you don't `}<em parentName="p">{`have to`}</em>{` use JSX with React. You don't "have to”; you "want to". Because that's what the library was designed for.`}</p>
    <p>{`MobX is a state management competitor to Redux, by the way. I like it because there's almost no boilerplate. We've been using at The Day Job™ and it's been amaze so far.`}</p>
    <p>{`A React component that reacts to MobX data store changes would use the `}<inlineCode parentName="p">{`@observer`}</inlineCode>{` decorator. Like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import React, { Component } from "react";
import { observer } from "mobx-react";
@observer
class Hello extends Component {
  render() {
    return <h1>Hello {this.props.store.name}</h1>;
  }
}
`}</code></pre>
    <p>{`You can think of decorators as function wrappers. A sort of functional composition, if you will.`}</p>
    <p>{`The observer decorator automatically runs a component’s `}<inlineCode parentName="p">{`render`}</inlineCode>{` method when MobX detects a change in a store value that `}<inlineCode parentName="p">{`render`}</inlineCode>{` references. Yes, MobX circumvents React's own prop and state change detection.`}</p>
    <p>{`I'm not sure yet how I feel about that, but so far, so good. Can't complain.`}</p>
    <p>{`It's those decorators that make working with MobX powerful and concise. But `}<inlineCode parentName="p">{`create-react-app`}</inlineCode>{` doesn't enable them because of some interesting history. They used to be in Babel 5, then Babel 6 removed them because the official spec got pushed back.`}</p>
    <p>{`There's a Babel plugin you can use, but `}<inlineCode parentName="p">{`create-react-app`}</inlineCode>{` maintainers have decided not to include it.`}</p>
    <h2 {...{
      "id": "how-to-get-decorators-in-create-react-app"
    }}>{`How to get decorators in create-react-app`}</h2>
    <p>{`Ok, so here's what you do when setting up a new React app:`}</p>
    <p><strong parentName="p">{`1)`}</strong>{` Run `}<inlineCode parentName="p">{`create-react-app`}</inlineCode>{`. This creates a new app with the official configuration.`}</p>
    <p><strong parentName="p">{`2)`}</strong>{` Run `}<inlineCode parentName="p">{`npm run eject`}</inlineCode>{`. This moves files around and makes your app's configuration accessible.`}</p>
    <p><strong parentName="p">{`3)`}</strong>{` Run `}<inlineCode parentName="p">{`npm install --saveDev babel-plugin-transform-decorators-legacy`}</inlineCode>{`. This installs the Babel plugin for decorators. It's called `}<inlineCode parentName="p">{`legacy`}</inlineCode>{` even though it's a feature from the far future.`}</p>
    <p><strong parentName="p">{`4)`}</strong>{` Open `}<inlineCode parentName="p">{`package.json`}</inlineCode>{`, find the `}<inlineCode parentName="p">{`"babel"`}</inlineCode>{` section (line 78 for me), and add 4 lines so it looks like this:`}</p>
    <p>{`"babel": {"plugins": `}{`[
"transform-decorators-legacy"
]`}{`,
"presets": `}{`[
"react-app"
]`}{`},`}</p>
    <p><strong parentName="p">{`5)`}</strong>{` Run `}<inlineCode parentName="p">{`npm install --save mobx mobx-react`}</inlineCode>{`. This installs MobX.`}</p>
    <p>{`You're ready to go. Happy hacking! ?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      